import { MessageCircle } from "lucide-react";

const WHATSAPP_LINK = "https://wa.me/2348032143826?text=Hello%204ACES%20Attorneys%2C%20I%20saw%20your%20website%20and%20would%20like%20to%20discuss%20a%20property%20transaction%20in%20Nigeria.";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      className="fixed bottom-6 right-6 z-50 group"
      data-testid="floating-whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      {/* Pulse animation ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      
      {/* Button */}
      <div className="relative flex items-center justify-center w-14 h-14 bg-[#25D366] rounded-full shadow-lg hover:bg-[#1da851] transition-all duration-300 hover:scale-110 hover:shadow-[0_0_20px_rgba(37,211,102,0.5)]">
        <MessageCircle className="w-7 h-7 text-white" fill="white" />
      </div>
      
      {/* Tooltip */}
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-[#0A0A0B] text-white text-sm px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none border border-[#D4AF37]/20">
        Chat with us
        <span className="absolute left-full top-1/2 -translate-y-1/2 border-8 border-transparent border-l-[#0A0A0B]" />
      </span>
    </a>
  );
};
